import React, { useEffect, useState, useMemo } from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import SignupContainer from '../../subcomponents/signupComp/SignupContainer';
import findAltText from '../../utils';

const SignEngage = ({ element, url, campaignType, order, version }) => {
  // get window width and reassign when resized
  // used for setting top/bottom padding (in mobile) with values from cms
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, [window.innerWidth]);

  const {
    cta,
    position,
    positionMobile,
    paddingMobile,
    paddingUnit,
    signupSource,
    signBackgroundColor,
    signTitleColor,
    signTextColor,
    signOpacity,
    mobileTitleColor,
    mobileTextColor,
    useMobileText,
    noBackground,
    backgroundColor,
    useGradient,
    backgroundGradient,
    gradientDirection,
    hide,
    type,
    signupNumber,
    anchorName,
    content,
    roundedCorners,
  } = element;
  const { slug, imagePattern } = url;

  const translations = window.campaign_data.campaign_translations.blocks;
  // If no background image, the engage will load immediately, otherwise pass loaded() to smartImage
  let displayTextColor = signTextColor;
  let displayTitleColor = signTitleColor;
  if (useMobileText && window.innerWidth < 768) {
    displayTextColor = mobileTextColor;
  }
  if (useMobileText && window.innerWidth < 768) {
    displayTitleColor = mobileTitleColor;
  }

  const roundTheCorners =
    campaignType === 'general' && roundedCorners ? 'rounded-corners' : '';

  const sectionClassNames = useMemo(
    () =>
      [
        'component',
        'signup-section',
        noBackground && 'smart-section',
        campaignType === 'general' && 'signup-height',
      ].join(' '),
    [noBackground, campaignType]
  );

  let imageName = `010-engage${imagePattern}`;
  if (campaignType === 'sale') imageName = `010-signup${imagePattern}`;
  if (campaignType === 'general')
    imageName = `010-signup${signupNumber}${imagePattern}`;
  let styler = {};
  if (noBackground && useGradient && gradientDirection === 'leftToRight') {
    styler = {
      background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)`,
    };
  } else if (
    noBackground &&
    useGradient &&
    gradientDirection === 'topToBottom'
  ) {
    styler = {
      background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)`,
    };
  } else if (noBackground && !useGradient) {
    styler = { background: backgroundColor };
  } else {
    styler = {};
  }

  const mainContentStyling = useMemo(
    () =>
      [
        'top-0',
        'bottom-0',
        'max-w-[1322px]',
        'absolute',
        'flex',
        noBackground && 'relative py-10',
        campaignType !== 'general' && 'mx-8 mt-[67%] h-fit',
        campaignType === 'general' && 'justify-center mt-0 w-full',
        campaignType === 'general' &&
          !noBackground &&
          (positionMobile === 'center' || !positionMobile) &&
          'items-center',
        'md:mt-0',
        'md:items-center',
        'md:w-3/4',
        'md:h-full',
        'md:right-0',
        'md:left-0',
        'md:mx-auto',
        position === 'center' && 'md:justify-center',
        position === 'left' && 'md:justify-start',
        position === 'right' && 'md:justify-end',
      ].join(' '),
    [noBackground, campaignType, position, positionMobile]
  );

  let spaceAroundContainerStyling = {};
  if (paddingMobile && windowWidth < 768) {
    if (positionMobile === 'top') {
      spaceAroundContainerStyling = {
        paddingTop: paddingMobile + paddingUnit,
        alignItems: 'flex-start',
      };
    } else if (positionMobile === 'bottom') {
      spaceAroundContainerStyling = {
        paddingBottom: paddingMobile + paddingUnit,
        alignItems: 'flex-end',
      };
    } else {
      spaceAroundContainerStyling = {};
    }
  }

  let component = null;
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={sectionClassNames}
        style={styler}
        dataorder={order}
        datatype={type}
      >
        {!noBackground && (
          <SmartImage
            className={`${campaignType === 'sale' ? 'saleHeightSignUp' : ''} ${
              campaignType === 'general' ? 'heightBackground' : ''
            }`}
            slug={slug}
            name={imageName}
            version={version}
            campaignType={campaignType}
            alt={findAltText(
              `SignUp Background ${signupNumber}`,
              campaignType === 'general'
                ? translations[`${content}title`]
                : translations.signuptitle
            )}
          />
        )}
        <main
          className={mainContentStyling}
          style={spaceAroundContainerStyling}
        >
          <SignupContainer
            backgroundColor={signBackgroundColor}
            opacity={signOpacity}
            titleColor={displayTitleColor}
            textColor={displayTextColor}
            ctaBackgroundColor={cta.ctaBackgroundColor}
            ctaTextColor={cta.ctaTextColor}
            ctaBorderColor={cta.ctaBorderColor}
            signupSource={signupSource}
            content={content}
            campaignType={campaignType}
            roundTheCorners={roundTheCorners}
          />
        </main>
      </section>
    );
  }

  return component;
};

export default SignEngage;
